import { render, staticRenderFns } from "./PagesOptions.vue?vue&type=template&id=81046f5c&scoped=true&lang=html"
import script from "./PagesOptions.vue?vue&type=script&lang=js"
export * from "./PagesOptions.vue?vue&type=script&lang=js"
import style0 from "./PagesOptions.vue?vue&type=style&index=0&id=81046f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81046f5c",
  null
  
)

export default component.exports